export default "__VITE_ASSET__BWQo2QSH__"